import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Carica la lingua salvata nel localStorage o default italiano
    if (typeof window !== 'undefined') {
      return localStorage.getItem('stibbert-language') || 'it';
    }
    return 'it';
  });

  useEffect(() => {
    // Salva la lingua nel localStorage quando cambia
    if (typeof window !== 'undefined') {
      localStorage.setItem('stibbert-language', language);
    }
  }, [language]);

  const changeLanguage = (langCode) => {
    setLanguage(langCode);
  };

  const value = {
    language,
    changeLanguage
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
